<div class="html-content" [innerHTML]="content"></div>
